"use strict";

var _toConsumableArray = require("/home/sho/app/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/home/sho/app/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/home/sho/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocomotiveScrollProvider = exports.LocomotiveScrollContext = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var use_debounce_1 = require("use-debounce");

var use_resize_observer_1 = tslib_1.__importDefault(require("use-resize-observer"));

exports.LocomotiveScrollContext = (0, react_1.createContext)({
  scroll: null,
  isReady: false
});

function LocomotiveScrollProvider(_ref) {
  var _this = this;

  var children = _ref.children,
      options = _ref.options,
      containerRef = _ref.containerRef,
      watch = _ref.watch,
      onUpdate = _ref.onUpdate,
      location = _ref.location,
      onLocationChange = _ref.onLocationChange;

  var _ref2 = (0, use_resize_observer_1.default)({
    ref: containerRef
  }),
      containerHeight = _ref2.height;

  var _ref3 = (0, react_1.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      isReady = _ref4[0],
      setIsReady = _ref4[1];

  var LocomotiveScrollRef = (0, react_1.useRef)(null);

  var _ref5 = (0, use_debounce_1.useDebounce)(containerHeight, 100),
      _ref6 = _slicedToArray(_ref5, 1),
      height = _ref6[0];

  if (!watch) {
    console.warn('react-locomotive-scroll: you did not add any props to watch. Scroll may have weird behaviours if the instance is not updated when the route changes');
  }

  (0, react_1.useEffect)(function () {
    ;

    (function () {
      return tslib_1.__awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var LocomotiveScroll, dataScrollContainer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Promise.resolve().then(function () {
                  return tslib_1.__importStar(require('locomotive-scroll'));
                });

              case 3:
                LocomotiveScroll = _context.sent.default;
                dataScrollContainer = document.querySelector('[data-scroll-container]');

                if (!dataScrollContainer) {
                  console.warn("react-locomotive-scroll: [data-scroll-container] dataset was not found. You likely forgot to add it which will prevent Locomotive Scroll to work.");
                }

                LocomotiveScrollRef.current = new LocomotiveScroll(Object.assign({
                  el: dataScrollContainer !== null && dataScrollContainer !== void 0 ? dataScrollContainer : undefined
                }, options));
                setIsReady(true); // Re-render the context

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                throw Error("react-locomotive-scroll: ".concat(_context.t0));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));
    })();

    return function () {
      var _a;

      (_a = LocomotiveScrollRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
      setIsReady(false);
    };
  }, []);
  (0, react_1.useEffect)(function () {
    if (!LocomotiveScrollRef.current) {
      return;
    }

    LocomotiveScrollRef.current.update();

    if (onUpdate) {
      onUpdate(LocomotiveScrollRef.current);
    }
  }, watch ? [].concat(_toConsumableArray(watch), [height]) : [height]);
  (0, react_1.useEffect)(function () {
    if (!LocomotiveScrollRef.current || !location) {
      return;
    }

    LocomotiveScrollRef.current.update();

    if (onLocationChange) {
      onLocationChange(LocomotiveScrollRef.current);
    }
  }, [location]);
  return (0, jsx_runtime_1.jsx)(exports.LocomotiveScrollContext.Provider, Object.assign({
    value: {
      scroll: LocomotiveScrollRef.current,
      isReady: isReady
    }
  }, {
    children: children
  }));
}

exports.LocomotiveScrollProvider = LocomotiveScrollProvider;
exports.LocomotiveScrollContext.displayName = 'LocomotiveScrollContext';
LocomotiveScrollProvider.displayName = 'LocomotiveScrollProvider';